import { render, staticRenderFns } from "./PrimaryNavigation.vue?vue&type=template&id=546846af&scoped=true"
import script from "./PrimaryNavigation.vue?vue&type=script&lang=ts"
export * from "./PrimaryNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546846af",
  null
  
)

export default component.exports